import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from './Icon';

interface Header3Props {
  title: string | null;
  hamBtnClick: () => void;
}

const Header3 = ({ title, hamBtnClick }: Header3Props) => {
  const navigate = useNavigate();

  return (
    <>
      <Header>
        <div className="title-box">
          <button onClick={() => navigate(-1)} className="img-box">
            <Icon name="ArrowLeftIcon" size="100%" color="#6B7684" />
          </button>
          <h1>{title}</h1>
        </div>
        <button className="ham-btn img-box" type="button" onClick={hamBtnClick}>
          <Icon name="HamIcon" size="100%" color="#B0B8C1" />
        </button>
      </Header>
    </>
  );
};

export default Header3;

const Header = styled.header`
  width: 100%;
  height: 66px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 8px 0 4px;

  .title-box {
    display: flex;
    align-items: center;
    gap: 12px;
    width: calc(100% - 44px);

    > .img-box {
      width: 32px;
    }

    > h1 {
      font-size: 18px;
      color: #000;
      font-weight: 700;
      line-height: 1.4;
      width: calc(100% - 44px);
    }
  }

  .ham-btn {
    width: 32px;
  }
`;
